export default __webpack_public_path__ + "static/media/fun4kids.82e12f3a.webp";